import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "edit-customer-manage"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("选择客户区域");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("选择客户类型");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("添加客户");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_7 = {
  class: "total"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("添加客户");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_10 = {
  class: "total"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "请下载Excel模版，严格按照模板上的提示信息填写，且不要修改Excel模板格式，保存后上传到系统，一次可最多导入500条。", -1);

const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "1.站点与客户编码必填，任何一项错误将会导入失败；", -1);

const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "2.仅可导入业务员可见站点下的客户；", -1);

import { reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getCustomerType, getCustomerArea, getAddedCustomers, getRemovedCustomers, delCustomer, saveCustomerAndValidateData, getSalesmanSupplierList, backupDataByActivityId } from '@/request';
import { excelImportCutomer, importCustomerImportExcel } from '@/request/api';
import { getVexTableProps } from '@/config';
import { uniqBy, pullAllBy } from 'lodash-es';
import { ElMessage, ElMessageBox } from 'element-plus';
import UploadModal from '@/components/UploadModal.vue';
import SelectAreaTreeModal from './component/SelectAreaTreeModal.vue';
import SelectCustomerTypeModal from './component/SelectCustomerTypeModal.vue';
import AddCustomerModal from './component/AddCustomerModal.vue';
export default {
  name: 'EditCustomerManage',

  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const supUserId = ref('');
    const showAreaTreeModal = ref(false);
    const showSelectCusTypeModal = ref(false);
    const showAddCustomerModal = ref(false);
    const supplierList = ref([]); // 业务员团队列表

    const formRef = ref();
    const cusType = ref(3);
    const table1 = ref();
    const table2 = ref();
    const showUploadModel = ref(false);
    const uploadOption = {
      action: excelImportCutomer.url,
      name: 'customer_excel',
      data: {
        customerBindSupUserId: supUserId.value
      },
      templateLink: importCustomerImportExcel.url,
      title: 'Excel导入'
    };
    const defaultParams = {
      moduleType: 20,
      readFromBackup: 1
    };
    let pageData = reactive({
      linkMan: route.query.linkMan,
      supplierName: route.query.supplierName,
      getCustomerTypeText: '',
      areaListText: '',
      defaultCheckedAreaIds: []
    }); // 获取业务员团队列表

    getSalesmanSupplierList({
      supAccountId: route.query.supAccountId
    }).then(data => {
      if (data.success) {
        supplierList.value = data.data;
        supUserId.value = data.data.length > 0 ? data.data[0].supUserId : '';
      }
    });

    function initCustomerType() {
      getCustomerType(_objectSpread({
        activityId: supUserId.value
      }, defaultParams)).then(data => {
        if (data.success) {
          pageData.customerTypeList = data.CustomerTypeList;
          pageData.getCustomerTypeText = data.CustomerTypeList.map(item => item.dictitemname).join(',');
        }
      });
    }

    function initAreaType() {
      getCustomerArea(_objectSpread({
        activityId: supUserId.value
      }, defaultParams)).then(data => {
        if (data.success) {
          pageData.defaultCheckedAreaIds = data.AreaList.map(item => item.areaCode);
          const areaArr = data.AreaList.reduce((prev, item) => prev.concat([item.custProvinceName, item.custCityName, item.custAreaName].filter(i => i)), []);
          pageData.areaListText = [...new Set(areaArr)].join(',');
        }
      });
    }

    function initData() {
      initCustomerType();
      initAreaType();
      table1.value.commitProxy('reload');
      table2.value.commitProxy('reload');
    }

    function goBack() {
      router.replace({
        name: route.query.from
      });
    }

    function save() {
      formRef.value.validate(e => {
        let body = {
          activityId: supUserId.value,
          areaCodes: pageData.defaultCheckedAreaIds.join(),
          custTypeCodes: pageData.customerTypeList.map(v => v.dictitemCode || v.custTypeId).join(),
          customerIds: table1Data.value.map(v => v.erpCustId).join(),
          removeCustomerIds: table2Data.value.map(v => v.erpCustId).join()
        };

        if (e) {
          saveCustomerAndValidateData(body).then(data => {
            if (data.success) {
              ElMessage.success('操作成功!');
              backupDataByActivityId({
                supUserId: supUserId.value
              }).then(() => {
                goBack();
              });
            }
          });
        }
      });
    }

    function addCus(type) {
      cusType.value = type;
      showAddCustomerModal.value = true;
    }

    function delCus(type = 1) {
      let table = type === 1 ? table1 : table2;
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作');
        return;
      }

      if (type === 1) {
        let newList = pullAllBy(table1Data.value, selectRows, 'erpCustId');
        table1.value.reloadData(newList);
        table1Data.value = newList;
      } else {
        let newList = pullAllBy(table2Data.value, selectRows, 'erpCustId');
        table2.value.reloadData(newList);
        table2Data.value = newList;
      } // ElMessageBox.confirm(
      //   `是否确认删除${selectRows.length}条数据`,
      //   '确认删除'
      // ).then(() => {
      //   delCustomer({
      //     RelationIds: selectRows.map((item) => item.RelationId).join(','),
      //     readFromBackup: 1,
      //     __repeat: true,
      //     __warn: true
      //   }).then((data) => {
      //     if (data.success) {
      //       ElMessage.success('操作成功!');
      //       table.value.commitProxy('reload');
      //     }
      //   });
      // });

    }

    function addCusSuccess(selectRows) {
      if (cusType.value === 3) {
        let uniqList = uniqBy([...selectRows, ...table1Data.value], 'erpCustId');
        table1.value.reloadData(uniqList);
        table1Data.value = uniqList;
      } else {
        let uniqList = uniqBy([...selectRows, ...table2Data.value], 'erpCustId');
        table2.value.reloadData(uniqList);
        table2Data.value = uniqList;
      }
    }

    function addCusTypesSuccess(selectRows) {
      pageData.customerTypeList = selectRows;
      pageData.getCustomerTypeText = pageData.customerTypeList.map(item => item.dictitemName).join(',');
    }

    const table1Data = ref([]);
    const tableOptions1 = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      maxHeight: '450px',
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '客户名称',
        field: 'custName',
        width: '150px',
        overflow: true
      }, {
        title: '所在区域',
        field: 'territories',
        width: '150px',
        overflow: true
      }, {
        title: '客户类型',
        field: 'dictitemName',
        width: '150px',
        overflow: true
      }, {
        title: '详细所在地',
        field: 'address',
        overflow: true
      }],
      pagerConfig: {
        pageSize: 10000,
        currentPage: 1,
        layouts: []
      },
      proxyConfig: {
        autoLoad: false,
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getAddedCustomers(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize,
              activityId: supUserId.value
            }, defaultParams)).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
              table1Data.value = data.rows;
            });
          })
        }
      }
    });
    const table2Data = ref([]);
    const tableOptions2 = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      maxHeight: '450px',
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '客户名称',
        field: 'custName',
        width: '150px',
        overflow: true
      }, {
        title: '所在区域',
        field: 'territories',
        width: '150px',
        overflow: true
      }, {
        title: '客户类型',
        field: 'dictitemName',
        width: '150px',
        overflow: true
      }, {
        title: '详细所在地',
        field: 'address',
        overflow: true
      }],
      pagerConfig: {
        pageSize: 10000,
        currentPage: 1,
        layouts: []
      },
      proxyConfig: {
        autoLoad: false,
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getRemovedCustomers(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize,
              activityId: supUserId.value
            }, defaultParams)).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
              table2Data.value = data.rows;
            });
          })
        }
      }
    });

    function areaSelectSuccessHandle(selectDatas) {
      pageData.defaultCheckedAreaIds = selectDatas.map(item => item.id);
      pageData.areaListText = [...new Set(selectDatas.map(item => item.text))].join();
    } // 切换团队 重新初始化数据


    watch(() => supUserId.value, () => {
      initData();
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_tab_pane = _resolveComponent("el-tab-pane");

      const _component_el_tabs = _resolveComponent("el-tabs");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        style: {
          "margin-bottom": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 2
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            icon: "Back",
            type: "primary",
            link: "",
            onClick: goBack
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form, {
        class: "form",
        "label-width": "80px",
        ref_key: "formRef",
        ref: formRef,
        model: _unref(pageData)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "联系人"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(pageData).linkMan,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(pageData).linkMan = $event),
                disabled: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "所属团队"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: supUserId.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => supUserId.value = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, supplier => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: supplier.supplierName,
                    value: supplier.supUserId,
                    key: supplier.supUserId
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 18
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "客户区域",
              prop: "areaListText",
              rules: {
                required: true,
                message: '请选择客户区域'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(pageData).areaListText,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(pageData).areaListText = $event),
                readonly: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "Plus",
              type: "primary",
              onClick: _cache[3] || (_cache[3] = $event => showAreaTreeModal.value = true)
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 18
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "客户类型",
              prop: "getCustomerTypeText",
              rules: {
                required: true,
                message: '请选择客户类型'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: _unref(pageData).getCustomerTypeText,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(pageData).getCustomerTypeText = $event),
                readonly: ""
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              icon: "Plus",
              type: "primary",
              onClick: _cache[5] || (_cache[5] = $event => showSelectCusTypeModal.value = true)
            }, {
              default: _withCtx(() => [_hoisted_4]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_el_tabs, {
        "model-value": "first",
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "补充客户单位",
          name: "first"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions1), {
            ref_key: "table1",
            ref: table1
          }), {
            tools: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Plus",
              onClick: _cache[6] || (_cache[6] = $event => addCus(3))
            }, {
              default: _withCtx(() => [_hoisted_5]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "danger",
              icon: "Delete",
              onClick: _cache[7] || (_cache[7] = $event => delCus(1))
            }, {
              default: _withCtx(() => [_hoisted_6]),
              _: 1
            })]),
            _: 1
          }, 16), _createElementVNode("div", _hoisted_7, "共" + _toDisplayString(table1Data.value.length) + "条记录", 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tabs, {
        "model-value": "first",
        class: "demo-tabs"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
          label: "剔除客户单位",
          name: "first"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions2), {
            ref_key: "table2",
            ref: table2
          }), {
            tools: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Plus",
              onClick: _cache[8] || (_cache[8] = $event => addCus(4))
            }, {
              default: _withCtx(() => [_hoisted_8]),
              _: 1
            }), _createVNode(_component_el_button, {
              type: "danger",
              icon: "Delete",
              onClick: _cache[9] || (_cache[9] = $event => delCus(2))
            }, {
              default: _withCtx(() => [_hoisted_9]),
              _: 1
            })]),
            _: 1
          }, 16), _createElementVNode("div", _hoisted_10, "共" + _toDisplayString(table2Data.value.length) + "条记录", 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end",
        style: {
          "margin-top": "10px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })]),
        _: 1
      }), _createVNode(SelectAreaTreeModal, {
        modelValue: showAreaTreeModal.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => showAreaTreeModal.value = $event),
        id: supUserId.value,
        defaultCheckedNodes: _unref(pageData).defaultCheckedAreaIds,
        onSuccess: areaSelectSuccessHandle
      }, null, 8, ["modelValue", "id", "defaultCheckedNodes"]), _createVNode(SelectCustomerTypeModal, {
        modelValue: showSelectCusTypeModal.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => showSelectCusTypeModal.value = $event),
        id: supUserId.value,
        onSuccess: addCusTypesSuccess
      }, null, 8, ["modelValue", "id"]), _createVNode(AddCustomerModal, {
        modelValue: showAddCustomerModal.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => showAddCustomerModal.value = $event),
        id: supUserId.value,
        custType: cusType.value,
        onSuccess: addCusSuccess
      }, null, 8, ["modelValue", "id", "custType"]), _createVNode(UploadModal, {
        option: uploadOption,
        onSuccess: _cache[13] || (_cache[13] = $event => table1.value.commitProxy('reload')),
        modelValue: showUploadModel.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => showUploadModel.value = $event)
      }, {
        help: _withCtx(() => [_hoisted_12, _hoisted_13, _hoisted_14]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};